var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      { staticClass: "mb-3", attrs: { "data-vv-scope": "assign-approval" } },
      [
        _c("list-group-users", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          ref: "resendName",
          staticClass: "w-100",
          attrs: {
            autocomplete: "",
            label: "Usuario",
            name: "resendSubject",
            "parent-value": _vm.stepOfficeId,
            danger: _vm.errors.has("assign-approval.resendSubject"),
            "danger-text": _vm.errors.first("assign-approval.resendSubject")
          },
          model: {
            value: _vm.resendSubject.id,
            callback: function($$v) {
              _vm.$set(_vm.resendSubject, "id", $$v)
            },
            expression: "resendSubject.id"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("vs-textarea", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "min:5",
              expression: "'min:5'"
            }
          ],
          staticClass: "mb-0",
          attrs: { maxlength: "255", label: "Comentario", name: "comment" },
          model: {
            value: _vm.comment,
            callback: function($$v) {
              _vm.comment = $$v
            },
            expression: "comment"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "text-right" },
      [
        _c(
          "b-button",
          {
            staticClass: "mt-3 text-right",
            attrs: { variant: "primary" },
            on: { click: _vm.sendAction }
          },
          [_vm._v(" Asignar ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }